import { _AuthApi } from "api/auth";
import { _axios as Axios } from "./http-config";

export const HttpRequestInterceptor = () => {
  Axios.interceptors.request.use(
    function (request) {
      // Do something before request is sent
      const token = _AuthApi.getToken();
      if (request.headers) {
        request.headers.Authorization = token ? `Bearer ${token}` : "";
        request.headers.Accept = "application/json";


        request.headers.lang = ["en", "ar"].includes(
          localStorage.getItem("i18nextLng")
        )
          ? localStorage.getItem("i18nextLng")
          : "en";
      }
      // request.headers["Access-Control-Allow-Origin"] = "*";
      // request.headers["Access-Control-Allow-Methods"] =
      //   "GET, POST, PUT, DELETE";
      // request.headers["Access-Control-Allow-Headers"] =
      //   "Content-Type, Authorization";
      return request;
    },
    function (error) {
      return Promise.reject(error);
    }
  );
};
